import { render, staticRenderFns } from "./FormMealBlockGeneralSettings.vue?vue&type=template&id=e18ffa6c"
import script from "./FormMealBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./FormMealBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports